import React from "react";
import unsplash from "../api/unsplash";
import SearchBar from "./SearchBar";
import ImageList from "./ImageList";

class App extends React.Component {
  // We initialize state with empty array because we expect
  // array as results. important to do this.
  state = { images: [] };

  onSearchSubmit = async term => {
    // We send a get request to unsplash api
    // This method is passed as props to the searchbar component and returned
    // with the submited value
    const response = await unsplash.get("/search/photos", {
      params: { query: term }
    });
    // We get the images from the ajax requests and update the state
    this.setState({ images: response.data.results });
  };

  render() {
    return (
      <div className="ui container" style={{ marginTop: "10px" }}>
        <SearchBar onSubmit={this.onSearchSubmit} />
        <ImageList images={this.state.images} />
      </div>
    );
  }
}

export default App;
